import React from 'react';
import Money from "../../../Common/Money";
import {ReactComponent as BasketIco} from "../../../../../images/icons/basket.svg";
import {getCartPrice, getFreeDeliveryPrice, getToFreeDeliveryPrice} from "../../../../utils/cart";
import {useTranslation} from "react-i18next";

interface Props {
    handleOnClick: () => void;
    loading: boolean;
    disabled: boolean;
    cart: any;
    session: any;
}

const CartButtonWithDeliveryInfo = ({handleOnClick, loading, disabled, cart, session}: Props) => {
    const freeDeliveryPrice = getFreeDeliveryPrice(session);
    const toFreeDeliveryPrice = getToFreeDeliveryPrice(session, cart);
    const {t, i18n} = useTranslation();
    const currency = cart.total?.currency ?? ""
    const percent = toFreeDeliveryPrice > 0 ? getCartPrice(cart) / freeDeliveryPrice : 100;

    const drawFreeDeliveryInfo = () => {
        return (
            <div className="d-flex flex-column btn-cart-with-delivery-info-container-simple">
                <div className="d-flex align-items-center justify-content-center">
                    <BasketIco className="basket-ico"/>
                    <Money value={cart.total}/>
                </div>
                <small>{t("modules.cart.field.free_delivery_available.title")}</small>
            </div>
        );
    };

    const drawToFreeDeliveryInfo = () => {
        return (
            <div className="btn-cart-with-delivery-info-container">
                <div className="left-box">
                    {t("modules.cart.field.to_free_delivery.title", {
                        money: Intl.NumberFormat(i18n.language, {
                            style: 'currency',
                            currency
                        }).format(toFreeDeliveryPrice),
                    })}
                    <div className="d-flex align-items-center gap-2 mt-2">
                        <span><Money value={getFreeDeliveryPrice(session)}/></span>
                        <div className="progress w-100" role="progressbar" aria-valuenow={percent * 100}
                             aria-valuemin={0} aria-valuemax={100}>
                            <div className="progress-bar"
                                 style={{width: `${percent * 100}%`}}></div>
                        </div>
                        <span><Money value={{amount: 0, currency}}/></span>
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-center right-box">
                    <span className="left spinner-border spinner-border-sm"/>
                    <BasketIco className="basket-ico"/>
                    <Money value={cart.total}/>
                </div>
            </div>
        )
    }

    const drawButtonContent = () => {
        if (toFreeDeliveryPrice <= 0) return drawFreeDeliveryInfo();
        return drawToFreeDeliveryInfo();
    }

    return (
        <button onClick={handleOnClick}
                className={"btn-cart-with-delivery-info btn-spinner btn btn-primary btn-submit" + (loading ? ' loading' : '')}
                disabled={disabled}>
            {toFreeDeliveryPrice < 0 && <span className="left spinner-border spinner-border-sm"/>}
            {drawButtonContent()}
        </button>
    )
}

export default CartButtonWithDeliveryInfo;